import { h } from 'preact';
import style from './style';
import cx from 'classnames';

export default function FavoritesCounter({ numFavorites, maxFavorites, ...props }) {
	const maxReached = numFavorites >= maxFavorites;
	return (
		<span {...props} class={cx(maxReached && style.maxReached, props.class)}>
			{`(${numFavorites}/${maxFavorites})`}
			{maxReached && ' Max Reached'}
		</span>
	);
}
